export const joinedConferenceSelector = (state, conferenceId) => {
    if (!state.joinedConferences) {
        return null;
    }
    const matchedJoinedConferences = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (matchedJoinedConferences.length === 1) {
        return matchedJoinedConferences[0];
    }
    return null;
};
export const joinedConferenceStateSelector = (state, conferenceId) => {
    if (!state.joinedConferences) {
        return null;
    }
    const matchedJoinedConferences = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (matchedJoinedConferences.length === 1) {
        return matchedJoinedConferences[0].state;
    }
    return null;
};
export const joinedConferenceSimpleViewSelector = (state, conferenceId) => {
    if (!state.joinedConferences) {
        return null;
    }
    const matchedJoinedConferences = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (matchedJoinedConferences.length === 1) {
        const { mode } = matchedJoinedConferences[0];
        return { name: conferenceId, mode };
    }
    return null;
};
export const joinedConferenceMetadataByKeySelector = (state, conferenceId, key) => {
    if (!state.joinedConferences) {
        return null;
    }
    const [conf] = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (conf && conf.conferenceState) {
        const match = Object.entries(conf.conferenceState.metadata || {})
            .filter(([k]) => [k].includes(key))
            .map(([, v]) => v);
        return match.length ? match : null;
    }
    return null;
};
export const joinedConferenceMetadataSelector = (state, conferenceId) => {
    if (!state.joinedConferences) {
        return null;
    }
    const [conf] = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    // avoid NPE if no conference state is loaded yet
    if (!conf.conferenceState) {
        return {};
    }
    return conf.conferenceState.metadata;
};
export const endpointMetadataSelector = (state, conferenceId, participantUserId, participantUserEndpointId) => {
    var _a;
    if (!state.joinedConferences) {
        return null;
    }
    const [conf] = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (!((_a = conf === null || conf === void 0 ? void 0 : conf.conferenceState) === null || _a === void 0 ? void 0 : _a.participants)) {
        return null;
    }
    const participant = conf.conferenceState.participants.find((p) => p.id === participantUserId);
    if (!participant) {
        return null;
    }
    const endpoint = participant.endpoints.find((e) => e.id === participantUserEndpointId);
    return endpoint === null || endpoint === void 0 ? void 0 : endpoint.metadata;
};
export const streamMetadataSelector = (state, conferenceId, participantUserId, participantUserEndpointId, participantStreamId) => {
    var _a;
    if (!state.joinedConferences) {
        return null;
    }
    const [conf] = state.joinedConferences.filter((item) => item.conferenceId === conferenceId);
    if (!((_a = conf === null || conf === void 0 ? void 0 : conf.conferenceState) === null || _a === void 0 ? void 0 : _a.participants)) {
        return null;
    }
    const participant = conf.conferenceState.participants.find((p) => p.id === participantUserId);
    if (!participant) {
        return null;
    }
    const endpoint = participant.endpoints.find((e) => e.id === participantUserEndpointId);
    if (!endpoint) {
        return null;
    }
    const stream = endpoint.streams.find((s) => s.id === participantStreamId);
    return stream === null || stream === void 0 ? void 0 : stream.metadata;
};
//# sourceMappingURL=selectors.js.map